import { EditButton, Drawer, Form, Input, Button, Grid, notification } from '@pankod/refine-antd';
import { useState, Dispatch, SetStateAction } from 'react';
import { IPointOfContact } from 'interfaces';
import { getAllPointOfContacts, updatePointOfContact } from 'services/point-of-contact';

type EditPointOfContactProps = {
  resource: string;
  resourceId: string;
  pointOfContact: IPointOfContact;
  setPointOfContacts: Dispatch<SetStateAction<IPointOfContact[]>>;
};

export const EditPointOfContact: React.FC<EditPointOfContactProps> = (props) => {
  const [visible, setVisible] = useState<boolean>(false);
  const breakpoint = Grid.useBreakpoint();

  const showDrawer = () => {
    setVisible(true);
  };

  const closeDrawer = () => {
    setVisible(false);
  };

  const onFinish = async (values: any) => {
    try {
      await updatePointOfContact(props.resource, props.pointOfContact.id, values);
      const data = await getAllPointOfContacts(props.resource, props.resourceId);
      props.setPointOfContacts(data);
      notification.success({
        message: 'Success',
        description: 'Successfully updated point of contact.',
      });
      closeDrawer();
    } catch (err) {
      return notification.error({
        message: 'Failed',
        description: 'Failed to update.',
      });
    }
  };

  return (
    <div>
      {!visible && <EditButton size="small" hideText onClick={showDrawer} />}
      <Drawer
        title="Edit Point Of Contact"
        placement="right"
        width={breakpoint.sm ? '450px' : '100%'}
        visible={visible}
        onClose={closeDrawer}
      >
        <Form
          layout="vertical"
          initialValues={{
            ...props.pointOfContact,
          }}
          onFinish={onFinish}
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item label="Designation" name="designation">
            <Input />
          </Form.Item>
          <Form.Item
            label="Phone"
            name="mobileNumber"
            rules={[
              {
                required: true,
              },
              {
                pattern: /^(\+\d{1,3}[- ]?)?\d{8,12}$/,
                message: 'Provide valid number',
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item wrapperCol={{ span: 4, offset: 20 }}>
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </div>
  );
};
